import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DayTable } from '../Calendar/DayTable';
import { CalendarBar } from '../Calendar/CalendarBar';
import Calendar from '../Calendar';
import { CupCalendarContainer } from './styles';
import CupCalendarTabbar from '../../components/CupCalendarTabbar';
import Label from '../../components/shared/Label';
import LastRow from '../../components/shared/LastRow';
import ConfigManager from '../../common/configManager/configManager';
import { getQuery, isRoundInterval } from '../../helpers';
import { isOnlyFirstLeg, isHideStandingLink, isHideLiveLink } from '../../common/rcs_gaz_mc_core_FE';
import BetFooter from '../../components/BetFooter';

class CupCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      betting: 0,
      currentPhase: '',
      currentSubPhase: '',
      loadEveryAdv: false,
    };
  }

  componentWillMount() {
    const query = getQuery(document.location);
    if (query && query.loadEveryAdv) {
      this.setState({
        loadEveryAdv: true,
      });
    }
    //this.loadBet();
  }

  componentDidMount() {
    this.resizeCallback();
    const { sportId, competitionId, seasonId } = window.matchcenterPage;
    const queryObj = getQuery(document.location);
    let outFase = false;
    let outSubfase = false;
    if (queryObj) {
      if (queryObj.fase) {
        outFase = queryObj.fase;
      }
      if (queryObj.subfase) {
        outSubfase = queryObj.subfase;
      }
      if (queryObj.giornata) {
        outSubfase = queryObj.giornata;
      }
    }
    if (outFase) {
      this.props.actions.getCupTabbar(sportId, competitionId, seasonId, outFase, outSubfase);
    } else {
      this.props.actions.getCupTabbar(sportId, competitionId, seasonId);
    }
    window.addEventListener('resize', this.resizeCallback);
    if (this.props.isSpecial) {
      document.querySelector('#root-header').style.display = 'none';
    }
  }

  componentWillReceiveProps(nextProps) {
    const queryObj = getQuery(document.location);
    let { currentPhase, currentSubPhase } = this.state;
    if (queryObj && queryObj.fase) {
      currentPhase = queryObj.fase;
    }
    if (queryObj && queryObj.subfase) {
      currentSubPhase = queryObj.subfase;
    }
    if (!currentPhase) {
      currentPhase = nextProps.cupTabbar.getIn(['lastPhase', 'label']);
    }
    if (!currentSubPhase) {
      currentSubPhase = nextProps.cupTabbar.get('lastSubPhase');
    }
    this.setState({ currentPhase, currentSubPhase });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  getLinkClassifica = () => {
    const { dictionary } = this.props;
    const { competitionId, seasonId } = window.matchcenterPage;
    let link = `${this.corriereLink()}${dictionary.standingsLink[ConfigManager.getEnv()]}${competitionId.toString() === '1277' ? 'mondiale-per-club-fifa' : dictionary.competitionLink[Number(competitionId)]}`;
    if (seasonId) {
      let seaPlus = (Number(seasonId) + 1).toString();
      seaPlus = seaPlus.substring(seaPlus.length - 2);
      link += `/${seasonId}-${seaPlus}`;
    }
    link += '/classifica/';
    return link;
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };


  dateTimeHandler = (datetime) => {
    const month = this.props.dictionary.date.months[datetime.getMonth()];
    const day = datetime.getDate();
    return `${day} ${month}`;
  };

  corriereLink = () => {
    let returnedLink = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      returnedLink = '/sport';
    }
    return returnedLink;
  };

  loadBet = () => {
    window.addEventListener('message', (e) => {
      if (e.data === 'mcQuoteTriggerAdv' || this.state.loadEveryAdv) {
        if (typeof window.top.matchCenterVarDfp === 'undefined' && this.state.loadEveryAdv) {
          window.top.matchCenterVarDfp = '3';
        }
        if (typeof window.top.matchCenterVarDfp !== 'undefined') {
          if (this.state.betting === 0) {
            //console.log('valore bet:', top.matchCenterVarDfp);
            let betType;
            if (window.top.matchCenterVarDfp === '1') {
              betType = 'sportpesa';
            } else if (window.top.matchCenterVarDfp === '2') {
              betType = 'planetwin';
            } else if (window.top.matchCenterVarDfp === '3') {
              betType = 'lottomatica';
            } else if (window.top.matchCenterVarDfp === '4') {
              betType = 'bet365';
            } else if (window.top.matchCenterVarDfp === '5') {
              betType = 'unibet';
            }
            if (process.env.REACT_APP_SITE !== 'corriere') {
              this.props.actions.getBetMatches(window.matchcenterPage.sportId, window.matchcenterPage.competitionId, betType);
              this.setState({
                betting: window.top.matchCenterVarDfp,
              });
              if (document.querySelector('.TeamHeaderWrapper')) {
                document.querySelector('.TeamHeaderWrapper').style.marginBottom = `${this.state.isMobile ? '100px' : '70px'}`;
              }
            }
          }
        }
      }
    });
  };

  render() {
    const {
      actions, dictionary, calendar,
      hasHighlights, cupTabbar, betMatch, isSpecial, isFootballSerieB, isUefaCompetition,
    } = this.props;
    const { sportId, competitionId } = window.matchcenterPage;
    const {
      isMobile, betting, currentPhase, currentSubPhase,
    } = this.state;
    const onlyFirstLeg = isOnlyFirstLeg(sportId, competitionId);
    const isRegular = (isFootballSerieB && currentPhase === 'regularSeason');
    const isUefaCompetitionChampionship = (isUefaCompetition && currentPhase === 'championship');
    return (
      <CupCalendarContainer>
        <CupCalendarTabbar
          currentPhase={isSpecial ? 'playoffs' : currentPhase || cupTabbar.getIn(['lastPhase', 'label'])}
          currentSubPhase={currentSubPhase || cupTabbar.get('lastSubPhase')}
          phases={cupTabbar.get('phases')}
          dictionary={dictionary}
          actions={actions}
          isMobile={isMobile}
          isCup
          isFootballSerieB={isFootballSerieB}
          isInnerMenu
          isUefaCompetition={isUefaCompetition}
        />
        {calendar && calendar.get('lastPhase') &&
        ((calendar.get('lastPhase') !== 'groups' && calendar.get('lastPhase') !== 'regularSeason' && calendar.get('lastPhase') !== 'championship') || (calendar.get('lastPhase') === 'preliminaries' && calendar.get('isGroups') !== true)) &&
          <div>
            {calendar && calendar.get('games') &&
              <CalendarBar
                dictionary={dictionary}
                actions={actions}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                competitionId={competitionId}
                isCup
                noTitleOnFinal={cupTabbar.get('lastSubPhase')}
              />
            }
            {calendar && calendar.get('games') && calendar.getIn(['games', 0, 'firstLeg']) && calendar.getIn(['games', 0, 'firstLeg']).map((c, index) => (
              <DayTable
                matchDate={c.get('date')}
                matches={c.get('matches')}
                dictionary={dictionary}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                actions={actions}
                key={index}
                betMatch={betMatch}
                betType={betting}
                loadEveryAdv={this.state.loadEveryAdv}
              />
            ))
            }
            {calendar && calendar.get('games') &&
            (cupTabbar.get('lastSubPhase') !== 'final' && cupTabbar.get('lastSubPhase') !== 'qualifier-round-1' &&
              competitionId !== 4 && competitionId !== 259 && competitionId !== 105 && competitionId !== 3 && !onlyFirstLeg) &&
              <Label
                label={dictionary.calendar.legs.secondLeg}
                isTitleNarrowMedium
                size={1.2}
                alignText={isMobile ? 'center' : 'left'}
                margin="0px 0px 20px 10px"
                block
              />
            }
            {calendar && calendar.get('games') &&
            (cupTabbar.get('lastSubPhase') === 'semi-finals' && competitionId === 259) &&
              <Label
                label={`${dictionary.calendar.legs.secondLeg}`}
                alignText={isMobile ? 'center' : 'left'}
                isTitleNarrowMedium
                size={1.2}
                margin="0px 0px 20px 10px"
                block
              />
            }
            {calendar && calendar.get('games') &&
            ((cupTabbar.get('lastSubPhase') === 'final' || cupTabbar.get('lastSubPhase') === 'semi-finals') && competitionId === 105) &&
              <Label
                label={dictionary.calendar.legs.secondLeg}
                isTitleNarrowMedium
                size={1.2}
                alignText={isMobile ? 'center' : 'left'}
                margin="0px 0px 20px 10px"
                block
              />
            }
            {calendar && calendar.get('games') && calendar.getIn(['games', 0, 'secondLeg']) && calendar.getIn(['games', 0, 'secondLeg']).map((c, index) => (
              <DayTable
                matchDate={c.get('date')}
                matches={c.get('matches')}
                dictionary={dictionary}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                actions={actions}
                key={index}
                betMatch={betMatch}
                betType={betting}
              />
            ))
            }
          </div>
        }
        {calendar && calendar.get('lastPhase') &&
        (calendar.get('lastPhase') === 'groups' || (calendar.get('lastPhase') === 'preliminaries' && calendar.get('isGroups') === true)) &&
          <div>
            {calendar.get('lastSubPhase') && !isRoundInterval(calendar.get('lastSubPhase')) && !calendar.get('preliminariesPlayoffs') && <CalendarBar
              dictionary={dictionary}
              actions={actions}
              hasHighlights={hasHighlights}
              isMobile={isMobile}
              currentSubPhase={cupTabbar.get('lastSubPhase')}
              isCup
            />}
            {calendar && calendar.get('games') && calendar.get('games').map((c, index) => (
              <DayTable
                groupsPhase
                matchDate={c.get('date')}
                matches={c.getIn(['matches', 0])}
                dictionary={dictionary}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                actions={actions}
                key={index}
                isGroups
                betMatch={betMatch}
                betType={betting}
                preliminariesPlayoffs={calendar.get('preliminariesPlayoffs')}
              />
            ))
            }
          </div>
        }
        {((isFootballSerieB && isRegular) || isUefaCompetitionChampionship) &&
          <Calendar
            dictionary={dictionary}
            actions={actions}
            calendar={calendar}
            isFootballSerieB={isFootballSerieB}
            hasHighlights={hasHighlights}
            isUefaCompetitionChampionship={isUefaCompetitionChampionship}
          />
        }
        {process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'corriere' ?
          <LastRow
            linkLabel1={isHideLiveLink(sportId, competitionId) ? null : 'Risultati Live'}
            linkLabel2={isHideStandingLink(sportId, competitionId) ? null : 'Classifica'}
            linkPath1={`${this.corriereLink()}/risultati-live/`}
            linkPath2={this.getLinkClassifica()}
          />
          : <LastRow
            linkLabel1="Classifica Marcatori"
            linkLabel2={isHideStandingLink(sportId, competitionId) ? null : 'Classifica'}
            linkPath1={`${dictionary.gazzanetStandingsLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/marcatori/`}
            linkPath2={`${dictionary.gazzanetStandingsLink[ConfigManager.getEnv()]}${dictionary.competitionLink[Number(competitionId)]}/classifica/`}
          />
        }
        {betting !== 0 && this.props.betMatch && <BetFooter />}
      </CupCalendarContainer>
    );
  }
}

CupCalendar.propTypes = {
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  calendar: PropTypes.any,
  hasHighlights: PropTypes.bool,
  cupTabbar: PropTypes.any,
  betMatch: PropTypes.any,
  isSpecial: PropTypes.any,
  isFootballSerieB: PropTypes.bool,
  isUefaCompetition: PropTypes.bool,
};

export default CupCalendar;



// WEBPACK FOOTER //
// ./src/containers/CupCalendar/index.js